import { useTenant } from "@timebanken/firebase-context"
import CenteredLayout from "@timebanken/react-components/components/layout/CenteredLayout"
import type React from "react"
import { useNavigate } from "react-router-dom"

export const TenantSelectionPage: React.FC = () => {
  const navigate = useNavigate()
  const { setDatabaseId, availableDatabases } = useTenant()

  // The list of databases is now stored persistently in TenantContext
  const databases = availableDatabases

  const handleCustomerSelect = (dbId: string) => {
    setDatabaseId(dbId)
    navigate("/")
  }

  if (databases.length === 0) {
    // This should not happen in normal flow, but handle it gracefully
    return (
      <CenteredLayout maxWidth="md">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-danger-600 mb-4">Error</h2>
          <p className="text-stone-700">
            No organizations found for your account. Please contact support.
          </p>
        </div>
      </CenteredLayout>
    )
  }

  return (
    <CenteredLayout maxWidth="md">
      <h2 className="text-3xl font-bold text-stone-800 mb-6 text-center">
        Velg organisasjon
      </h2>
      <p className="text-stone-600 mb-8 text-center">
        Kontoen din er tilknyttet flere organisasjoner. Velg hvilken du vil logge
        inn på:
      </p>

      <div className="space-y-4">
        {databases.map((db) => (
          <button
            type="button"
            key={db.databaseId}
            onClick={() => handleCustomerSelect(db.databaseId)}
            className="w-full py-3 px-4 rounded-xl border-2 border-sand-200 hover:border-primary-500 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200 text-left"
          >
            <div className="font-semibold text-stone-800">
              {db.customerName}
            </div>
          </button>
        ))}
      </div>
    </CenteredLayout>
  )
}
